var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ContentContainer from "../../atoms/ContentContainer";
import Title from "../../atoms/Title";
import axios, { errorsTransformer } from "../../../Http";
import * as Endpoint from "../../../Http";
import ErrorNotice from "../../atoms/ErrorNotice";
import Paragraph from "../../atoms/Paragraph";
import Loader from "../../atoms/icons/Loader";
import { withRouter } from "react-router-dom";
import Button from "../../atoms/Button";
import { useTranslation } from "react-i18next";
import FrameFooter from "../../atoms/FrameFooter";
import LanguageToggle from "../../molecules/LanguageToggle";
import LanguageSelector from "../../molecules/LanguageSelector";
import LanguageSelection from "../../atoms/LanguageSelect";
import { bugsnagClient } from "../../../services/bugsnag";
import { getQueryParameter } from "../../../helpers/Url";
const StyledVerifyFrame = styled.div `
  width: 100%;
  margin: 0 auto;

  @media only screen and (min-width: 768px) {
    width: 450px;
    max-width: none;
    margin: 0 auto;
  }

  @media only screen and (min-width: 992px) {
    width: 526px;
  }
`;
const LoginHeader = styled(Title) `
  font-size: 24px;
  font-family: ${props => props.theme.fontHead};
  font-weight: 700;
  margin-bottom: 20px;

  @media only screen and (min-width: 768px) {
    font-size: 35px;
  }
`;
const ContentWrapper = styled.div `
  margin-bottom: 20px;
`;
const StyledParagraph = styled(Paragraph) `
  margin-bottom: 20px;
  font-size: 15px;

  @media only screen and (min-width: 768px) {
    font-size: 17px;
  }
`;
const StyledButton = styled(Button) `
  margin-top: 20px;
  font-weight: 500;
`;
const StyledAnchor = styled.a `
  position: relative;
  display: inline-block;
  color: ${props => props.theme.tertiary};
  font-family: ${props => props.theme.fontBase};
  margin-top: 0;
  font-size: 14px;
  text-decoration: none;

  &:before {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${props => props.theme.tertiary};
  }
`;
const StyledContentContainer = styled(ContentContainer) `
  box-shadow: 0 2px 60px rgba(26, 26, 33, 0.12);
`;
const LinkContainer = styled.div `
  text-align: center;
`;
const StyledErrorNotice = styled(ErrorNotice) `
  margin-bottom: 15px;
`;
const LoaderWrapper = styled.div `
  display: flex;
  justify-content: center;
`;
const Verify = (_a) => {
    var { amountInCents, dossierNumber, debtorPortal } = _a, props = __rest(_a, ["amountInCents", "dossierNumber", "debtorPortal"]);
    const { t } = useTranslation(["common", "payment_portal"]);
    const [errors, setErrors] = useState({});
    const [status, setStatus] = useState("loading");
    const [isExpanded, setExpanded] = useState(false);
    const token = getQueryParameter('token');
    const verifyPayment = () => {
        setStatus("loading");
        const storedPaymentId = localStorage.getItem("payment_portal.payment_id") || sessionStorage.getItem("payment_portal.payment_id");
        if (!storedPaymentId && !token) {
            bugsnagClient.notify("Payment ID not found in localStorage");
            setStatus("error");
            return;
        }
        axios
            .get(Endpoint.VERIFY_OPEN_PAYMENT, {
            params: {
                payment_id: storedPaymentId,
                dossier: dossierNumber,
                token,
            }
        })
            .then(data => {
            setStatus(data.data.payment_status);
        })
            .catch(err => {
            bugsnagClient.notify("Error: " + (err === null || err === void 0 ? void 0 : err.message));
            err = errorsTransformer(err);
            setStatus("error");
            setErrors(err.errors);
        });
    };
    useEffect(() => {
        verifyPayment();
    }, []);
    const paymentStatusBlock = () => {
        if (status === "loading") {
            return (React.createElement(LoaderWrapper, null,
                React.createElement(Loader, null)));
        }
        const failedPaymentStatusTranslations = {
            failed: t("payment_portal:verify.failed"),
            expired: t("payment_portal:verify.expired"),
            canceled: t("payment_portal:verify.canceled")
        };
        if (status in failedPaymentStatusTranslations) {
            return (React.createElement(React.Fragment, null,
                React.createElement(StyledErrorNotice, null, t("payment_portal:verify.status_erroneous", {
                    status: failedPaymentStatusTranslations[status]
                })),
                React.createElement(StyledButton, { onClick: () => (window.location.href = `/i/${dossierNumber}/${amountInCents}`), primary: true, wide: true }, t("payment_portal:verify.retry"))));
        }
        if (status === "paid") {
            return (React.createElement(React.Fragment, null,
                React.createElement(StyledParagraph, null, t("payment_portal:verify.status_paid")),
                React.createElement(StyledParagraph, null, t("payment_portal:verify.close_notice")),
                React.createElement(StyledButton, { onClick: () => (window.location.href = `/i/${dossierNumber}`), primary: true, wide: true }, t("payment_portal:verify.another_payment"))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(StyledErrorNotice, null, t("payment_portal:verify.status_unknown")),
            React.createElement(StyledParagraph, null, t("payment_portal:verify.status_unknown_help")),
            React.createElement(StyledButton, { onClick: () => verifyPayment(), primary: true, wide: true }, t("payment_portal:verify.status_unknown_retry"))));
    };
    return (React.createElement(StyledVerifyFrame, null,
        React.createElement(StyledContentContainer, { largeGutter: true, borderRadius: true, hasShadow: true },
            React.createElement(LoginHeader, { tag: "h1" }, t("app_name")),
            React.createElement(ContentWrapper, null, paymentStatusBlock()),
            React.createElement(FrameFooter, null,
                React.createElement(LinkContainer, null,
                    React.createElement(StyledAnchor, { href: debtorPortal + "/login" }, t("payment_portal:verify.view_dossier"))),
                React.createElement(LanguageSelection, { onlyShowOnMobile: true },
                    React.createElement(LanguageToggle, { onClick: (event) => {
                            setExpanded(prevToggle => !prevToggle);
                            event.preventDefault();
                        } }),
                    React.createElement(LanguageSelector, { isExpanded: isExpanded, isReversed: true }))))));
};
export default withRouter(Verify);
